import moment from 'moment';

const { REACT_APP_ENVIRONMENT: ENVIRONMENT } = process.env;

export const FORM_STATE = {
  UPDATE: 'UPDATE',
  CREATE: 'CREATE',
};

export const TASKTYPE_SCHEMA = {
  s_cost: {
    name: 'Costs',
    type: 'decimal',
    uom: 'USD',
  },
  s_deeplink_fdg: {
    name: 'Open FDG Reading View',
    type: 'deeplink',
  },
  s_desc: {
    name: 'Task Description',
    type: 'string',
  },
  s_estimatedtime: {
    display_format: 'hh:mm',
    name: 'Estimated Time',
    type: 'time',
  },
  s_name: {
    name: 'Task Name',
    type: 'string',
  },
  s_timespent: {
    display_format: 'hh:mm',
    name: 'Task Time',
    type: 'time',
  },
  s_workordernumber: {
    Name: 'Work Order Number',
    type: 'string',
  },
};

export const TASK_SOURCE = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  NON_SUBSCRIPTION: 'NON_SUBSCRIPTION',
};

export const EVENT_SOURCE_OPTIONS = [
  'Manual',
  'Recurring',
  'SCADA',
  'SAP-PM',
  'Joyn-DR',
  'Oracle-EAM',
  'Auto',
  'Infor EAM',
  'API',
  'Land',
];

export const DEFAULT_TRAVEL_TIME = 7200; // seconds

export const ACTIVITY_STATUS = {
  driving: {
    Name: 'Driving',
    Color: 'rgb(255,106,57)',
  },
  available: {
    Name: 'Available',
    Color: 'rgb(65, 189, 94)',
  },
  working_on_task: {
    Name: 'Working on Task',
    Color: 'rgb(6, 144, 214)',
  },
};
export const VIEWS = {
  taskGridView: 'taskGridView',
  mapView: 'mapView',
  schedulerView: 'schedulerView',
  recurringTaskGridView: 'recurringTaskGridView',
};

export const ROUTE = 'Route';

const timeZoneNames = moment.tz && moment.tz.names();
export const timeZoneDropdownOptions = (timeZoneNames || []).map((key) => {
  const text = key.replace(/_/g, ' ');
  return { key, text, value: key };
});

export const LOCAL_STORAGE_ADMIN_UI_VERSION = 'ADMIN_UI_VERSION';

export const DEFAULT_SCORE_COEFFICIENTS = [
  {
    value: 0,
    label: '0 ( consider travel time only )',
  },
  {
    value: 0.01,
    label: '0.01 ( consider travel time as major component along with score )',
  },
  {
    value: 0.5,
    label: '0.5 ( consider travel time along with score )',
  },
  {
    value: 1,
    label: '1 ( consider score as major component along with travel time )',
  },
  {
    value: 5,
    label: '5 ( consider score aggressively along with travel time )',
  },
];

export const DEFAULT_RUN_ENGINE_SETTINGS = {
  highScoreCoefficient: '2',
  highScoreThreshold: '100',
  scoreCoefficient: 0.01,
  timeLimit: '20000',
  enableClustering: true,
  enableGroupClustering: false,
  unassignUsers: false,
  balanceTechTimeCoefficient: 0,
  useCrowFlyDistances: true,
  disableTechEndLocation: false,
  useUserLocation: false,
  disableAvailabilityRestriction: false,
  timeBuffer: 0,
  balanceTechShiftUtilization: false,
  crowFlyDistanceFactorPercentage: 0,
  startTimeLte: '00:00',
  autoFreezTimeLte: '',
};

export const DEFAULT_PLANNING_ENGINE_SETTINGS = {
  highScoreCoefficient: '0',
  highScoreThreshold: '100000',
  scoreCoefficient: 0.01,
  timeLimit: '60000',
  enableClustering: false,
  enableGroupClustering: false,
  unassignUsers: true,
  balanceTechTimeCoefficient: 0,
  balanceTechShiftUtilization: false,
  // useCrowFlyDistances: true,
  // disableTechEndLocation: false,
  useUserLocation: false,
  disableAvailabilityRestriction: false,
  timeBuffer: 0,
  crowFlyDistanceFactorPercentage: 0,
};

export function getDefaultScoreCoefficient(value) {
  value = isNaN(value) ? DEFAULT_RUN_ENGINE_SETTINGS.scoreCoefficient : parseFloat(value);
  const values = DEFAULT_SCORE_COEFFICIENTS.map((item) => item.value);

  if (values.indexOf(value) === -1) {
    return DEFAULT_RUN_ENGINE_SETTINGS.scoreCoefficient;
  }
  return value;
}

export const DEFAULT_AUTOMATE_DAILY_RUN_AREA_SETTINGS = {
  schedule: [],
};

export const PUBLISH_AS_PLANNED_OPTIONS = [
  {
    id: 'firstRun',
    name: 'First run of the day(s)',
  },
  {
    id: 'allRuns',
    name: 'All runs of the day(s)',
  },
  {
    id: 'noRun',
    name: 'No run',
  },
];

export const DEFAULT_PUBLISH_AS_PLANNED_OPTION_ID = PUBLISH_AS_PLANNED_OPTIONS[1].id;

export const DEFAULT_AUTOMATE_DAILY_RUN_SCHEDULE_ROW_SEETINGS = {
  enabled: true,
  name: '',
  selectedDays: [],
  runOnFixedTime: true,
  fixedTimeList: [],
  frequencyHour: 0,
  frequencyMinutes: 0,
  frequencyStartTime: '00:00',
  frequencyEndTime: '00:00',
  // useDefaultEngineSettings: false,
  engineSettings: {},
  timeZone: moment.tz && moment.tz.guess(),
  modifiedBy: '',
  modifiedOn: '',
  id: '',
  publishAsPlanned: DEFAULT_PUBLISH_AS_PLANNED_OPTION_ID,
  areaIds: [],
};

export const AUTOMATE_DAILY_RUN_TABLE_COLUMNS = [
  {
    headerName: 'Schedule Name',
    field: 'name',
  },
  {
    headerName: 'Areas',
    field: 'areas',
  },
  {
    headerName: 'Schedule Days',
    field: 'selectedDaysDesc',
  },
  {
    headerName: 'Runs On',
    field: 'frequency',
  },
  {
    headerName: 'Publish As Planned For',
    field: 'publishAsPlanned',
  },
  {
    headerName: 'Status',
    field: 'status',
  },
  {
    headerName: 'Modified By',
    field: 'modifiedBy',
  },
  {
    headerName: 'Modified On',
    field: 'modifiedOn',
  },
  {
    headerName: 'Actions',
    field: 'actionButtons',
    cellRenderer: 'actionsColumnRenderer',
    filter: false,
  },
];

export const UPDATE_ASSET_BY_UPLOAD_COLUMNS = [
  {
    headerName: 'Stop Name',
    field: 'name',
  },
  {
    headerName: 'Start Date',
    field: 'startDate',
  },
  {
    headerName: 'End Date',
    field: 'endDate',
  },
  {
    headerName: 'Start Time',
    field: 'startTime',
  },
  {
    headerName: 'End Time',
    field: 'endTime',
  },
];

export const DAYS_OF_WEEK_MIN_NAMES = moment.weekdaysMin();

export const DAYS_OF_WEEK_SHORT_NAMES = moment.weekdaysShort();

export const DAYS_OF_WEEK = moment.weekdays().map((day, index) => {
  return { id: index, name: day, minName: DAYS_OF_WEEK_MIN_NAMES[index], shortName: DAYS_OF_WEEK_SHORT_NAMES[index] };
});

export const GRIDS_DATE_DISPLAY_FORMAT = 'YYYY-MM-DD';

export const MIN_SCHEDULE_FREQUENCY = 15; // 15 minutes.

export const MODAL_CHECK_BOX_LABEL_STYLE = {
  cursor: 'pointer',
  position: 'relative',
  top: '1px',
};

export const MODAL_CHECK_BOX_STYLE = {
  marginRight: '0.4em',
  cursor: 'pointer',
};

export const ENGINE_LOGS_VIEW = {
  ENGINE_ALL_LOGS_VIEW: 'ENGINE_ALL_LOGS_VIEW',
  ENGINE_SINGLE_LOG_VIEW: 'ENGINE_SINGLE_LOG_VIEW',
};

export const SCHEDULER_DEFAULT_COLORS = { eventColor: '#9FCE63', color: 'black' };

export const SCHEDULER_TASK_STATES = {
  DIRTY: 'dirty',
  DRAFT: 'draft',
  PUBLISHED: 'published',
};

export const getEventState = (isDirty, draftState) => {
  // eslint-disable-next-line no-nested-ternary
  return isDirty
    ? SCHEDULER_TASK_STATES.DIRTY
    : draftState
    ? SCHEDULER_TASK_STATES.DRAFT
    : SCHEDULER_TASK_STATES.PUBLISHED;
};

export const SCHEDULER_DRIVE_EVENT_TYPE = 'driveTime';

export const CURRENT_WORKFLOW_VERSION = 'v1';

export const ERRORS = {
  SUBSCRIPTION_TIMED_OUT_ERROR: 'Timed Out',
  DECOMPRESSION_INVALID_INPUT_ERROR: 'Invalid input for Decompression',
};

export const EditMode = {
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
};

export const TaskStatus = {
  DRAFT: 'draft',
  OPEN: 'open',
};

export const PLanningMode = {
  PLANNINGPUBLISHED: 'PLANNINGPUBLISHED',
  PLANNINGINPROGRESS: 'PLANNINGINPROGRESS',
  PLANNINGUNPUBLISHED: 'PLANNINGUNPUBLISHED',
};

export const WATCHER_GROUP_ENTITY_TYPES = {
  GLOBAL_ATTRIBUTE: 'globalattribute',
};

export const WATCHER_GROUP_ENTITY_TYPES_CONFIG = {
  [WATCHER_GROUP_ENTITY_TYPES.GLOBAL_ATTRIBUTE]: {
    id: WATCHER_GROUP_ENTITY_TYPES.GLOBAL_ATTRIBUTE,
    name: 'Global Attribute',
  },
};

export const DEFAULT_WATCHER_GROUP_CONFIG = {
  entityType: WATCHER_GROUP_ENTITY_TYPES.GLOBAL_ATTRIBUTE,
  entityId: '',
  entityPicklistWatcherGroupMappingId: '',
};

// export const EXISTING_CUSTOM_KEYS = ['c_uplift', 'c_actualcost'];

export const VENDOR_VARIABLE_NAME = 'VENDOR';
export const PICKLIST_VENDOR_NAME = 'Vendor'; // FDG PickList name
export const CERTIFICATES_VARIABLE_NAME = 'CERTIFICATES';
export const PICKLIST_CERTIFICATES_NAME = 'Certifications';
export const SKILLLEVEL_VARIABLE_NAME = 'SKILLLEVEL';
export const PICKLIST_SKILLLEVEL_NAME = 'SkillLevels';
export const ACLQUALIFIED_VARIABLE_NAME = 'ACLQUALIFIED';
export const PICKLIST_ACLQUALIFIED_NAME = 'ACLQualified';
export const PREFERRED_LOCATION_TYPE = 'PreferredLocationType';
export const PRIORITY_INCREMENT_PICKLIST = 'PriorityIncrement';
export const TASK_TYPE_GROUP = 'TaskTypeGroup';
export const WATCHER_GROUP = 'WatcherGroup';

export const TASK_ATTRIBUTES_NEEDED = [
  'approvedBy',
  'approvedOn',
  'asset',
  'assetId',
  'assignee',
  'assigneeIds',
  'assignedOn',
  'attachments',
  'completedOn',
  'createdOn',
  'createdBy',
  'data',
  'duration',
  'endTime',
  'eventSource',
  'fieldId',
  'id',
  'isHardAssignee',
  'isPlanned',
  'isRecurring',
  'priority',
  'schedule',
  'sourceRecurringTaskId',
  'originalRecurrenceDate',
  'deletedForRecurrenceDates',
  'priorityScore',
  'isHardStartTime',
  'startTime',
  'status',
  'taskType',
  'taskTypeId',
  'tenantId',
  'parentTaskId',
  'workflowVersion',
  'workflowStepId',
  'modifiedOn',
  'modifiedBy',
  'increment',
  'dependsOn',
  'isDeleted',
  'delayMinutes',
  'resolvedBy',
  'resolvedOn',
  'linkedTaskIds',
  'watcherIds',
  'parts',
  'formSchemaId',
  'formSectionId',
  'globalAttributes',
  'template',
  'onlyAllowManualScoreUpdate',
  'requestorIds',
  'approvalInfo',
  'approvalStatus',
  'approverIds',
  'scheduled',
  'taskNumber',
  'rejectedIds',
  'watcherGroupIds',
  'immediateNextTo',
  'sameStartTimeAs',
  'timeToNextPriority',
  'isTaskLocked',
  'recurrenceInactive',
  'draftState',
  'readingId',
  'rulesEvaluated',
  'assetLevelsInfo',
  'nextRecurrenceDate',
  'prevRecurrenceDate',
];

export const TASK_ACTION = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  APPROVE: 'APPROVE',
};

export const MapViewSVGIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
<path fill="none" stroke="#424F62" stroke-width=".8" d="M1 4.75C1 2.679 2.79 1 5 1s4 1.679 4 3.75C9 7.25 5 11 5 11S1 7.25 1 4.75h0z"/>
</svg>`;

export const gridViewSVGIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
<g fill="#424F62">
    <path d="M4.23 0H.386C.172 0 0 .172 0 .385V4.23c0 .212.172.384.385.384H4.23c.212 0 .384-.172.384-.384V.385C4.615.172 4.443 0 4.231 0zm-.384 3.846H.77V.77h3.077v3.077zM9.615 0H5.77c-.212 0-.384.172-.384.385V4.23c0 .212.172.384.384.384h3.846c.213 0 .385-.172.385-.384V.385C10 .172 9.828 0 9.615 0zm-.384 3.846H6.154V.77H9.23v3.077zM4.23 5.385H.386c-.213 0-.385.172-.385.384v3.846c0 .213.172.385.385.385H4.23c.212 0 .384-.172.384-.385V5.77c0-.212-.172-.384-.384-.384zM3.847 9.23H.77V6.154h3.077V9.23zM9.615 5.385H5.77c-.212 0-.384.172-.384.384v3.846c0 .213.172.385.384.385h3.846c.213 0 .385-.172.385-.385V5.77c0-.212-.172-.384-.385-.384zM9.231 9.23H6.154V6.154H9.23V9.23z"/>
</g>
</svg>`;

export const schedulerViewSVGIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7">
<g fill="#424F62">
    <path d="M9.517 0H.483C.216 0 0 .224 0 .5s.216.5.483.5h9.034C9.784 1 10 .776 10 .5S9.784 0 9.517 0zM.483 7h9.034c.267 0 .483-.224.483-.5S9.784 6 9.517 6H.483C.216 6 0 6.224 0 6.5s.216.5.483.5zM9.62 3H5v1h4.62c.21 0 .38-.224.38-.5S9.83 3 9.62 3zM.672 4H3V3H.672C.302 3 0 3.224 0 3.5s.301.5.672.5z"/>
</g>
</svg>
`;

export const recurringTaskSVGIcon = (color) => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
<path fill="${color}" d="M9.304 0C14.107 0 18 3.893 18 8.696c0 4.802-3.893 8.696-8.696 8.696-.37 0-.669-.3-.669-.67 0-.369.3-.668.67-.668 4.063 0 7.357-3.294 7.357-7.358s-3.294-7.358-7.358-7.358-7.358 3.294-7.358 7.358c0 1.825.668 3.54 1.837 4.865v-2.352c0-.37.3-.669.67-.669.37 0 .669.3.669.67v3.783c0 .37-.3.67-.67.67H.67c-.37 0-.669-.3-.669-.67 0-.37.3-.669.669-.669h2.006C1.358 12.777.608 10.798.608 8.697.608 3.893 4.502 0 9.304 0zm0 4.282c.37 0 .669.3.669.669v4.36l2.172 2.172c.262.261.262.685 0 .946-.26.261-.684.261-.946 0l-2.368-2.368c-.125-.126-.196-.296-.196-.473V4.95c0-.37.3-.67.67-.67z"/>
</svg>
`;
};

export const ACTION_MENU = {
  CREATE_TASK: {
    key: 'CREATE_TASK',
    value: 'CREATE_TASK',
    text: 'Create Task',
  },
  BULK_CREATE_TASKS: {
    key: 'BULK_CREATE_TASKS',
    value: 'BULK_CREATE_TASKS',
    text: 'Bulk Create Tasks',
  },
  RUN_DAILY_ENGINE: {
    key: 'RUN_DAILY_ENGINE',
    value: 'RUN_DAILY_ENGINE',
    text: 'Run Daily Engine',
  },
  DAILY_ENGINE_SETTINGS: {
    key: 'DAILY_ENGINE_SETTINGS',
    value: 'DAILY_ENGINE_SETTINGS',
    text: 'Daily Engine Settings',
  },
  PLANNING_ENGINE_SETTINGS: {
    key: 'PLANNING_ENGINE_SETTINGS',
    value: 'PLANNING_ENGINE_SETTINGS',
    text: 'Planning Engine Settings',
  },
  AUTOMATE_DAILY_ENGINE_RUN: {
    key: 'AUTOMATE_DAILY_ENGINE_RUN',
    value: 'AUTOMATE_DAILY_ENGINE_RUN',
    text: 'Automate Daily Engine Run',
  },
  ENGINE_LOG: {
    key: 'ENGINE_LOG',
    value: 'ENGINE_LOG',
    text: 'Engine Log',
  },
  ENGINE_SIMULATOR: { key: 'ENGINE_SIMULATOR', value: 'ENGINE_SIMULATOR', text: 'Engine Simulator' },
};
export const closeIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
<g fill="none" fill-rule="evenodd" stroke="#424F62" transform="translate(1 1)">
    <rect width="16" height="16" stroke-width="1.5" rx="8"/>
    <g fill="#424F62" fill-rule="nonzero" stroke-linejoin="round">
        <path d="M4.068 0L4.694 0 4.694 8.761 4.068 8.761z" transform="translate(3.765 3.765) rotate(45 4.38 4.38)"/>
        <path d="M0 4.068L8.761 4.068 8.761 4.694 0 4.694z" transform="translate(3.765 3.765) rotate(45 4.38 4.38)"/>
    </g>
</g>
</svg>`;
export const COLOR_PALETTE = [
  '#0153a5',
  '#2698f8',
  '#ffa02c',
  '#a585e6',
  '#6ed055',
  '#48c3ff',
  '#2cc2da',
  '#7ad0a1',
  '#2ac59d',
  '#a0ec72',
  '#35700f',
  '#6ed055',
  '#ffe36b',
  '#ffca1a',
  '#00b0f0',
  '#ffca1a',
  '#da6093',
  '#ff7f8c',
  '#f55241',
];

export const arrowDownSvg = (color = '#fff') => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8">
<path fill="none" fill-rule="evenodd" stroke="${color}" d="M1609 194.64L1615.32 188.32 1609 182" transform="rotate(90 901.66 -706.18)"/>
</svg>
`;
};
export const needAcceptanceIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
<g>
    <path d="M4.45 6.397L3.02 4.967 3.457 4.53 4.483 5.563 6.57 3.788 6.967 4.252z"/>
    <path d="M5 10c-2.755 0-5-2.245-5-5s2.245-5 5-5 5 2.245 5 5-2.238 5-5 5zM5 .616C2.583.616.616 2.583.616 5 .616 7.417 2.583 9.384 5 9.384c2.417 0 4.384-1.967 4.384-4.384C9.391 2.583 7.424.616 5 .616z"/>
</g>
</svg>
`;

export const startClockSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
<path fill="#4C4C4C" d="M4 8c2.21 0 4-1.79 4-4S6.21 0 4 0 0 1.79 0 4s1.79 4 4 4zm0-3.861V2.182c0-.201.163-.364.364-.364.2 0 .363.163.363.364v2.182c0 .137-.078.263-.2.325l-1.455.727c-.18.09-.398.017-.488-.162-.09-.18-.017-.399.162-.488L4 4.139z"/>
</svg>
`;

export const endClockSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
<path fill="#4C4C4C" d="M4 8C1.79 8 0 6.21 0 4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-3.861V2.182c0-.201-.163-.364-.364-.364-.2 0-.363.163-.363.364v2.182c0 .137.078.263.2.325l1.455.727c.18.09.398.017.488-.162.09-.18.017-.399-.162-.488L4 4.139z"/>
</svg>
`;

export const delayIconSVG = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>delay 2</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="delay-2" transform="translate(1.000000, 1.000000)" fill="#424F62" fill-rule="nonzero" stroke="#3F4F64" stroke-width="0.3">
            <g id="delay">
                <path d="M8,0 C3.58095238,0 0,3.58095238 0,8 C0,12.4190476 3.58095238,16 8,16 C12.4190476,16 16,12.4190476 16,8 C16,3.58095238 12.4190476,0 8,0 Z M8,15.2380952 C4,15.2380952 0.761904762,12 0.761904762,8 C0.761904762,4 4,0.761904762 8,0.761904762 C12,0.761904762 15.2380952,4 15.2380952,8 C15.2380952,12 12,15.2380952 8,15.2380952 Z" id="Shape"></path>
                <g id="Group-80" transform="translate(7.500000, 4.000000)">
                    <rect id="Rectangle" x="0" y="0" width="1" height="6"></rect>
                    <rect id="Rectangle" x="0" y="7" width="1" height="1"></rect>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export const hardStartIconSVG = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="18px" viewBox="0 0 16 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>hardstart</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="hardstart" transform="translate(1.000000, 1.000000)" fill="#424F62" fill-rule="nonzero" stroke="#3F4E64" stroke-width="0.4">
            <path d="M7.34885246,2.13485714 C11.0163934,2.33257143 13.9311475,5.36 13.9311475,9.06171429 C13.9311475,12.8902857 10.8109836,15.9988571 6.96557377,15.9988571 C3.12131148,15.9988571 -2.66453526e-15,12.8914286 -2.66453526e-15,9.06171429 C-2.66453526e-15,5.36 2.91819672,2.33142857 6.5857377,2.13485714 L6.58114754,0.762285714 L5.31655738,0.764571429 C5.10655738,0.764571429 4.93557377,0.594285714 4.93557377,0.385142857 C4.93557377,0.176 5.10655738,0.00571428571 5.31655738,0.00571428571 L8.61114754,-1.86517468e-14 C8.82114754,-1.86517468e-14 8.99213115,0.170285714 8.99213115,0.379428571 C8.99213115,0.588571429 8.82114754,0.758857143 8.61114754,0.758857143 L7.34196721,0.761142857 L7.34655738,2.13485714 L7.34885246,2.13485714 Z M6.96672131,2.88685714 C3.54016393,2.88685714 0.766557377,5.64914286 0.766557377,9.06171429 C0.766557377,12.4742857 3.54016393,15.2365714 6.96672131,15.2365714 C10.3932787,15.2365714 13.1668852,12.4742857 13.1668852,9.06171429 C13.1668852,5.64914286 10.3932787,2.88685714 6.96672131,2.88685714 Z" id="Shape"></path>
            <path d="M6.96672131,10.04 C6.74639344,10.04 6.5857377,9.88 6.5857377,9.66057143 L6.58,6.37942857 C6.58,6.17028571 6.75098361,6 6.96098361,6 C7.17098361,6 7.34196721,6.17028571 7.34196721,6.37942857 L7.34655738,9.28114286 L10.3818033,9.27885714 C10.5918033,9.27885714 10.7627869,9.44914286 10.7627869,9.65828571 C10.7627869,9.86742857 10.5918033,10.0377143 10.3818033,10.0377143 L6.96557377,10.04 L6.96672131,10.04 Z" id="Path"></path>
        </g>
    </g>
</svg>`;

export const scoreIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
<path fill="#FFF" stroke="#4C4C4C" stroke-linejoin="round" stroke-width=".8" d="M7.7 3.093L5.7 5.067 6.25 7.947 3.85 6.507 1.45 7.893 2 5.013 0 3.04 2.7 2.667 3.85 0 5 2.667z" transform="translate(1 1)"/>
</svg>
`;

export const bullPointCloseSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<g fill="#424F62">
    <path d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10c0-2.652-1.054-5.196-2.929-7.071C15.196 1.054 12.652 0 10 0zm0 18.182c-4.519 0-8.182-3.663-8.182-8.182S5.481 1.818 10 1.818 18.182 5.481 18.182 10c0 2.17-.862 4.251-2.397 5.785-1.534 1.535-3.615 2.397-5.785 2.397z"/>
    <path d="M10.64 7.1c-.17-.17-.401-.267-.642-.267-.242 0-.473.096-.643.267l-3.673 3.673c-.355.355-.355.93 0 1.286.355.355.931.355 1.286 0L10 9.027l3.032 3.032c.355.355.931.355 1.286 0s.355-.931 0-1.286L10.641 7.1z"/>
</g>
</svg>
`;

export const bullPointOpenSVG = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>open</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Joyn-2-Ghantt-Chart-View-Copy-3" transform="translate(-886.000000, -562.000000)" fill="#424F62" fill-rule="nonzero">
            <g id="Group-12" transform="translate(896.000000, 572.000000) scale(1, -1) translate(-896.000000, -572.000000) translate(886.000000, 562.000000)">
                <path d="M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,7.3478351 18.9464316,4.80429597 17.0710678,2.92893219 C15.195704,1.0535684 12.6521649,0 10,0 L10,0 Z M10,18.1818182 C5.48130659,18.1818182 1.81818182,14.5186934 1.81818182,10 C1.81818182,5.48130659 5.48130659,1.81818182 10,1.81818182 C14.5186934,1.81818182 18.1818182,5.48130659 18.1818182,10 C18.1818182,12.1699531 17.3198077,14.2510306 15.7854191,15.7854191 C14.2510306,17.3198077 12.1699531,18.1818182 10,18.1818182 Z" id="Shape"></path>
                <path d="M10.6409091,7.1 C10.4703925,6.9292936 10.2390084,6.83337577 9.99772727,6.83337577 C9.75644614,6.83337577 9.52506205,6.9292936 9.35454545,7.1 L5.68181818,10.7727273 C5.3265987,11.1279468 5.32659871,11.7038714 5.68181821,12.0590909 C6.03703771,12.4143104 6.6129623,12.4143104 6.96818182,12.0590909 L10,9.02727273 L13.0318182,12.0590909 C13.3870377,12.4143104 13.9629623,12.4143104 14.3181818,12.0590909 C14.6734013,11.7038714 14.6734013,11.1279468 14.3181818,10.7727273 L10.6409091,7.1 Z" id="Path"></path>
            </g>
        </g>
    </g>
</svg>`;

export const multiAssigneeIconSVG = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>multiassign</title>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="multiassign" transform="translate(-0.000086, 0.000510)" fill="#424F62" fill-rule="nonzero">
            <g id="Shape-13" transform="translate(0.000086, -0.000510)">
                <path d="M2.00006856,8.79959179 C2.84285736,8.79710431 3.59333324,8.26571462 3.87558856,7.47159179 L5.61214856,7.71959179 C5.64358149,8.24936889 5.88582014,8.74450608 6.28478856,9.09447179 L5.02006856,11.3078318 C4.82051581,11.2388446 4.61119221,11.2023008 4.40006856,11.1995918 C3.42150055,11.1890309 2.57583577,11.8808068 2.39223237,12.8420543 C2.20862897,13.8033018 2.73979692,14.75806 3.65336831,15.1089079 C4.56693969,15.4597558 5.60064091,15.1059697 6.1076537,14.2689243 C6.6146665,13.431879 6.44943457,12.3518784 5.71534856,11.7047118 L6.98006856,9.49135179 C7.4475398,9.65614402 7.9608542,9.63209272 8.41086856,9.42431179 L10.1393486,11.8428718 C9.44473277,12.5963282 9.43331224,13.7533139 10.1129195,14.5203351 C10.7925267,15.2873564 11.9424693,15.4153344 12.7740839,14.8164982 C13.6056985,14.217662 13.8489305,13.0864748 13.3369645,12.198737 C12.8249985,11.3109991 11.724088,10.9549905 10.7892686,11.3748718 L9.06078856,8.95631179 C9.37499738,8.61792623 9.5614257,8.18059763 9.58798856,7.71959179 L11.3245486,7.47159179 C11.668774,8.43937996 12.6899282,8.98928477 13.6873996,8.74401782 C14.6848711,8.49875086 15.3345725,7.53800155 15.1907453,6.52093772 C15.046918,5.50387388 14.156293,4.76094852 13.1299257,4.80188097 C12.1035585,4.84281342 11.274925,5.65430437 11.2125486,6.67959179 L9.47598856,6.92759179 C9.2422205,6.27037718 8.6829205,5.78244106 8.00006856,5.63999179 L8.00006856,3.95959179 C9.00605385,3.75424591 9.69313638,2.82051231 9.58994087,1.79898208 C9.48674536,0.777451842 8.626798,-3.26849658e-13 7.60006856,-3.26849658e-13 C6.57333913,-3.26849658e-13 5.71339177,0.777451842 5.61019626,1.79898208 C5.50700075,2.82051231 6.19408327,3.75424591 7.20006856,3.95959179 L7.20006856,5.64039179 C6.51746253,5.78289104 5.95835859,6.27063677 5.72454856,6.92759179 L3.98798856,6.67959179 C3.92042804,5.59496975 2.99755668,4.76372294 1.91179836,4.80953 C0.826040047,4.85533706 -0.0235375694,5.76136172 0.000497621392,6.84782006 C0.0245328121,7.93427839 0.913346738,8.80184546 2.00006856,8.79959179 Z M4.40006856,14.3995918 C3.73732686,14.3995918 3.20006856,13.8623335 3.20006856,13.1995918 C3.20006856,12.5368501 3.73732686,11.9995918 4.40006856,11.9995918 C5.06281026,11.9995918 5.60006856,12.5368501 5.60006856,13.1995918 C5.59931908,13.8620228 5.06249957,14.3988423 4.40006856,14.3995918 Z M12.8000686,13.1995918 C12.8000686,13.8623335 12.2628103,14.3995918 11.6000686,14.3995918 C10.9373269,14.3995918 10.4000686,13.8623335 10.4000686,13.1995918 C10.4000686,12.5368501 10.9373269,11.9995918 11.6000686,11.9995918 C12.2624996,12.0003413 12.7993191,12.5371608 12.8000686,13.1995918 Z M13.2000686,5.59959179 C13.8628103,5.59959179 14.4000686,6.13685009 14.4000686,6.79959179 C14.4000686,7.46233349 13.8628103,7.99959179 13.2000686,7.99959179 C12.5373269,7.99959179 12.0000686,7.46233349 12.0000686,6.79959179 C12.000818,6.13716079 12.5376376,5.60034128 13.2000686,5.59959179 Z M6.40006856,1.99959179 C6.40006856,1.33685009 6.93732686,0.799591794 7.60006856,0.799591794 C8.26281026,0.799591794 8.80006856,1.33685009 8.80006856,1.99959179 C8.80006856,2.66233349 8.26281026,3.19959179 7.60006856,3.19959179 C6.93763756,3.19884231 6.40081804,2.6620228 6.40006856,1.99959179 L6.40006856,1.99959179 Z M7.60006856,6.39959179 C8.26281026,6.39959179 8.80006856,6.93685009 8.80006856,7.59959179 C8.80006856,8.26233349 8.26281026,8.79959179 7.60006856,8.79959179 C6.93732686,8.79959179 6.40006856,8.26233349 6.40006856,7.59959179 C6.40081804,6.93716079 6.93763756,6.40034128 7.60006856,6.39959179 L7.60006856,6.39959179 Z M2.00006856,5.59959179 C2.66281026,5.59959179 3.20006856,6.13685009 3.20006856,6.79959179 C3.20006856,7.46233349 2.66281026,7.99959179 2.00006856,7.99959179 C1.33732686,7.99959179 0.800068563,7.46233349 0.800068563,6.79959179 C0.800818045,6.13716079 1.33763756,5.60034128 2.00006856,5.59959179 Z" id="Shape"></path>
            </g>
        </g>
    </g>
</svg>`;

export const arrowUpSVG = () => {
  return `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 490.523 490.523" style="enable-background:new 0 0 490.523 490.523;" xml:space="preserve">
<path style="fill:#FFC107;" d="M487.411,355.047L252.744,120.38c-4.165-4.164-10.917-4.164-15.083,0L2.994,355.047
 c-4.093,4.237-3.976,10.99,0.262,15.083c4.134,3.993,10.687,3.993,14.821,0l227.115-227.115l227.115,227.136
 c4.237,4.093,10.99,3.976,15.083-0.261c3.993-4.134,3.993-10.688,0-14.821L487.411,355.047z"/>
<path d="M479.859,373.266c-2.831,0.005-5.548-1.115-7.552-3.115L245.192,143.015L18.077,370.151
 c-4.237,4.093-10.99,3.976-15.083-0.262c-3.993-4.134-3.993-10.687,0-14.821l234.667-234.667c4.165-4.164,10.917-4.164,15.083,0
 l234.667,234.667c4.159,4.172,4.148,10.926-0.024,15.085C485.388,372.146,482.681,373.265,479.859,373.266z"/>
</svg>`;
};

export const printIconSVG = () => {
  return `<?xml version="1.0" encoding="UTF-8"?>
  <svg width="14px" height="15px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Shape</title>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Joyn-2-Task-Form-View-Copy-4" transform="translate(-888.000000, -1122.000000)" fill="#424F62" fill-rule="nonzero" stroke="#3F4F64" stroke-width="0.1">
              <g id="Group-63" transform="translate(883.000000, 1117.000000)">
                  <path d="M8.80668258,16.5349887 L7.2601432,16.5349887 C6.57279236,16.5349887 6,15.9480813 6,15.214447 L6,10.4018059 C6,9.69751693 6.57279236,9.11060948 7.2601432,9.11060948 L8.80668258,9.11060948 L8.80668258,6.29345372 C8.80668258,6.14672686 8.92124105,6 9.09307876,6 L14.9069212,6 C15.0787589,6 15.1933174,6.11738149 15.1933174,6.29345372 L15.1933174,9.11060948 L16.7398568,9.11060948 C17.4272076,9.11060948 18,9.69751693 18,10.4018059 L18,15.214447 C18,15.9480813 17.4272076,16.5349887 16.7398568,16.5349887 L15.1933174,16.5349887 L15.1933174,18.7065463 C15.1933174,18.8826185 15.0787589,19 14.9069212,19 L9.09307876,19 C8.92124105,19 8.80668258,18.8826185 8.80668258,18.7065463 L8.80668258,16.5349887 Z M9.37947494,9.11060948 L14.6205251,9.11060948 L14.6205251,6.58690745 L9.37947494,6.58690745 L9.37947494,9.11060948 Z M15.1933174,15.9480813 L16.7398568,15.9480813 C17.1121718,15.9480813 17.4272076,15.6252822 17.4272076,15.214447 L17.4272076,10.4018059 C17.4272076,10.020316 17.1121718,9.69751693 16.7398568,9.69751693 L7.2601432,9.69751693 C6.88782816,9.69751693 6.57279236,10.020316 6.57279236,10.4018059 L6.57279236,15.214447 C6.57279236,15.6252822 6.88782816,15.9480813 7.2601432,15.9480813 L8.80668258,15.9480813 L8.80668258,14.510158 C8.80668258,14.3340858 8.92124105,14.2167043 9.09307876,14.2167043 L14.9069212,14.2167043 C15.0787589,14.2167043 15.1933174,14.3340858 15.1933174,14.510158 L15.1933174,15.9480813 Z M14.6205251,14.8036117 L9.37947494,14.8036117 L9.37947494,18.4130926 L14.6205251,18.4130926 L14.6205251,14.8036117 Z" id="Shape"></path>
              </g>
          </g>
      </g>
  </svg>`;
};

export const resolvedIconSVG = () => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
  <g id="Group_9424" data-name="Group 9424" transform="translate(-1106 -387)">
    <rect id="Rectangle" width="8" height="8" rx="4" transform="translate(1106.5 387.5)" fill="#009574" stroke="#009574" stroke-width="1"/>
    <g id="Path_3" data-name="Path 3" transform="translate(1107.908 389.618)">
      <path id="Path" d="M4.488.132,1.881,2.646.8,1.482A.458.458,0,0,0,.354,1.35a.467.467,0,0,0-.335.326.478.478,0,0,0,.11.459l1.4,1.49a.438.438,0,0,0,.32.14.423.423,0,0,0,.32-.124L5.113.8A.472.472,0,0,0,5.128.148a.437.437,0,0,0-.64-.016Z" transform="translate(0 0)" fill="#fff" stroke="#fff" stroke-width="0.25"/>
    </g>
  </g>
</svg>
`;
};

export const IMAGE_ATTACHMENT_UPLOAD_BUCKET_NAME = `slt-joyn2-assets-${ENVIRONMENT}`;

export const FILE_UPLOAD_FORMAT_OPTIONS = {
  pdf: {
    id: 'pdf',
    name: 'PDF',
    acceptedExtension: '.pdf',
  },
  image: {
    id: 'image',
    name: 'Image - Png, JPEG',
    acceptedExtension: 'image/*',
  },
  document: {
    id: 'document',
    name: 'Document - Doc, Docx',
    acceptedExtension: '.doc,.docx,.txt,application/msword',
  },
  sheets: {
    id: 'sheets',
    name: 'Sheets - Xls, Xlsx',
    acceptedExtension: '.xls,.xlsx,.csv',
  },
};

export const DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB = 10;

export const getIconNameForFileExtension = (extension) => {
  switch (extension) {
    case '.jpg':
    case '.jpeg':
    case '.png':
    case '.gif':
      return 'file image outline';
    case '.pdf':
      return 'file pdf outline';
    case '.xls':
    case '.xlsx':
    case '.csv':
      return 'file excel outline';
    default:
      return 'file outline';
  }
};

export const THEME_COLOUR = {
  LIGHT: '#FFF',
  DARK: '#000',
};
export const SIGNATURE_FILE_TYPE = {
  PDF: 'pdf',
  IMAGE: 'image',
};

export const pendingAcceptanceIconSVG = () => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
  <g fill="none" fill-rule="evenodd">
      <path fill="#A2A2A0" d="M6 0c3.317 0 6 2.683 6 6s-2.683 6-6 6-6-2.683-6-6 2.683-6 6-6z" transform="translate(1)"/>
      <path fill="#FFF" fill-rule="nonzero" d="M7.479 8c-.101 0-.2-.024-.284-.07l-1.96-1.075C5.088 6.774 5 6.636 5 6.488V3.436c0-.24.232-.436.52-.436.286 0 .519.195.519.436V6.25l1.723.948c.194.105.282.305.216.49-.065.186-.269.313-.5.312z" transform="translate(1)"/>
  </g>
</svg>
`;
};
export const acceptedIconSVG = () => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12">
  <g fill="none" fill-rule="evenodd">
      <path fill="#00CFBB" d="M6 0c3.317 0 6 2.683 6 6s-2.683 6-6 6-6-2.683-6-6 2.683-6 6-6z" transform="translate(1)"/>
      <path fill="#FFF" d="M3 6.712l.62-.593 1.772 1.695L9.38 4l.62.593L5.392 9 3 6.712z" transform="translate(1)"/>
  </g>
</svg>
`;
};

export const unlockIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<path data-name="Subtraction 1" d="M16759.527 21113.582h-7.26a1.256 1.256 0 0 1-1.266-1.271v-6.168a1.253 1.253 0 0 1 1.266-1.268v-2.209a3.606 3.606 0 0 1 1.053-2.578 3.6 3.6 0 0 1 5.109-.045 3.6 3.6 0 0 1 1.1 2.494l-.729-.025a2.9 2.9 0 0 0-5.8.154v2.209h4.166l2.7.047a1.252 1.252 0 0 1 .926 1.221v6.168a1.256 1.256 0 0 1-1.265 1.271zm-7.26-7.98a.534.534 0 0 0-.541.541v6.205a.52.52 0 0 0 .5.508h7.328a.576.576 0 0 0 .387-.184.5.5 0 0 0 .121-.361v-6.168a.533.533 0 0 0-.539-.541z" transform="translate(-16744 -21094)" style="fill:#424f62;stroke:#424f62;stroke-width:.8px"/>
</svg>
`;

export const lockIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
<defs>
    <style>
        .cls-2{fill:#424f62;stroke:#424f62;stroke-width:.8px}
    </style>
</defs>
<g id="lock" transform="translate(-270 -285)">
    <g id="Group_2014" data-name="Group 2014" transform="translate(116 -294.818)">
        <path id="Path_459" data-name="Path 459" class="cls-2" d="M30.525 14.677v-2.213A3.646 3.646 0 0 0 26.9 8.8a3.646 3.646 0 0 0-3.628 3.664v2.213A1.262 1.262 0 0 0 22 15.946v6.167a1.262 1.262 0 0 0 1.27 1.27h7.255a1.262 1.262 0 0 0 1.27-1.27v-6.167a1.262 1.262 0 0 0-1.27-1.269zM24 12.464a2.9 2.9 0 1 1 5.8 0v2.213H24zm7.074 9.649a.526.526 0 0 1-.508.544H23.27a.526.526 0 0 1-.544-.508v-6.2a.534.534 0 0 1 .544-.544h7.255a.534.534 0 0 1 .544.544z" transform="translate(139 576.018)"/>
        <path id="Path_460" data-name="Path 460" class="cls-2" d="M47.363 63.2a.364.364 0 0 0-.363.363v1.451a.363.363 0 0 0 .726 0v-1.451a.364.364 0 0 0-.363-.363z" transform="translate(118.535 531.484)"/>
    </g>
</g>
</svg>
`;

export const LOCAL_STORAGE_SELECTED_DATE_RANGE = 'SELECTED_DATE_RANGE';

export const DD_MM_YYYY_FORMAT = 'DD-MM-YYYY';
export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
export const MM_DD_YYYY_FORMAT = 'MM-DD-YYYY';

export const FORMAT_TYPES_ENUM = {
  ISOSTRING: 'isostring',
  FORMAT: 'regularformat',
};

export const ACCEPTANCE_STATUS = {
  ACCEPTED: { label: 'Accepted' },
  REJECTED: { label: 'Rejected' },
  PENDING_ACCEPTANCE: { label: 'Pending Acceptance' },
};

export const SUBSCRIPTION_ERROR_MESSAGES = {
  'Connection closed': false,
  'Timeout disconnect': false,
  'Connection failed: Connection handshake error':
    'JOYN FSM is having trouble subscribing to live data updates. Please check your internet connection. Otherwise, please contact your IT/cybersecurity team for help.',
};

export const DRIVE_TIME_FROM_START_STOP = 'DRIVE_TIME_FROM_START_STOP';
export const DRIVE_TIME_FROM_END_STOP = 'DRIVE_TIME_FROM_END_STOP_';
export const MAX_PICKLIST_COUNT_FOR_MAPPING = 5;
export const MIN_PICKLIST_COUNT_FOR_MAPPING = 2;

export const TASK_DATE_TYPES = {
  CREATEDON: { value: 'createdOn', key: 'createdOn', text: 'Created On' },
  MODIFIEDON: { value: 'modifiedOn', key: 'modifiedOn', text: 'Modified On' },
  TASKDATE: { value: 'startTime', key: 'startTime', text: 'Task Date' },
  RESOLVEDON: { value: 'resolvedOn', key: 'resolvedOn', text: 'resolved On' },
};

export const DATE_RANGE_TYPES = {
  LAST7DAYS: {
    value: 'last7days',
    key: 'last7days',
    text: 'Last 7 Days',
    subtractInfo: {
      number: 6,
      text: 'days',
    },
  },
  LAST14DAYS: {
    value: 'last14days',
    key: 'last14days',
    text: 'Last 14 Days',
    subtractInfo: {
      number: 13,
      text: 'days',
    },
  },
  LAST30DAYS: {
    value: 'last30days',
    key: 'last30days',
    text: 'Last 30 Days',
    subtractInfo: {
      number: 29,
      text: 'days',
    },
  },
  LAST60DAYS: {
    value: 'last60days',
    key: 'last60days',
    text: 'Last 60 Days',
    subtractInfo: {
      number: 59,
      text: 'days',
    },
  },
  LAST90DAYS: {
    value: 'last90days',
    key: 'last90days',
    text: 'Last 90 Days',
    subtractInfo: {
      number: 89,
      text: 'days',
    },
  },
  LAST180DAYS: {
    value: 'last180days',
    key: 'last180days',
    text: 'Last 180 Days',
    subtractInfo: {
      number: 179,
      text: 'days',
    },
  },
  LAST365DAYS: {
    value: 'last365days',
    key: 'last365days',
    text: 'Last 365 Days',
    subtractInfo: {
      number: 364,
      text: 'days',
    },
  },
  // LAST3MONTHS: {
  //   value: 'last3months',
  //   key: 'last3months',
  //   text: 'Last 3 Months',
  //   subtractInfo: {
  //     number: 3,
  //     text: 'months',
  //   },
  // },
  // LAST6MONTHS: {
  //   value: 'last6months',
  //   key: 'last6months',
  //   text: 'Last 6 Months',
  //   subtractInfo: {
  //     number: 6,
  //     text: 'months',
  //   },
  // },
  // LASTYEAR: {
  //   value: 'lastyear',
  //   key: 'lastyear',
  //   text: 'Last Year',
  //   subtractInfo: {
  //     number: 1,
  //     text: 'year',
  //   },
  // },
  SINCEINCEPTION: {
    value: 'sinceinception',
    key: 'sinceinception',
    text: 'Since Inception',
    subtractInfo: {
      number: 20,
      text: 'year',
    },
  },
  CUSTOMDATERANGE: {
    value: 'customdaterange',
    key: 'customdaterange',
    text: 'Custom Date Range',
    subtractInfo: {
      number: 0,
      text: 'days',
    },
  },
};

export const USAGE_DASHBOARD_COLUMNS = [
  DATE_RANGE_TYPES.LAST30DAYS,
  DATE_RANGE_TYPES.LAST90DAYS,
  DATE_RANGE_TYPES.LAST180DAYS,
  DATE_RANGE_TYPES.LAST365DAYS,
  DATE_RANGE_TYPES.SINCEINCEPTION,
];

export const MAX_FILE_LIMIT_IN_MULTI_FILE_UPLOAD_ELEMENT = 50;

export const dailyEngineSettingsOptions = () => {
  return [
    {
      key: 0,
      text: 'Time Limit',
      value: 'timeLimit',
    },
    {
      key: 1,
      text: 'Score Cost Co-efficient',
      value: 'scoreCoefficient',
    },
    {
      key: 2,
      text: 'Same Start Time Buffer',
      value: 'timeBuffer',
    },
    {
      key: 3,
      text: 'Keep existing Assignments for on-shift Users',
      value: 'unassignUsers',
    },
    {
      key: 4,
      text: 'Disable Tech End Location',
      value: 'disableTechEndLocation',
    },
    {
      key: 5,
      text: 'Enable Clustering',
      value: 'enableClustering',
    },
    {
      key: 6,
      text: 'Enable Group Clustering',
      value: 'enableGroupClustering',
    },

    {
      key: 7,
      text: 'Use Crow Fly Distances',
      value: 'useCrowFlyDistances',
    },
    {
      key: 8,
      text: 'Use User Location',
      value: 'useUserLocation',
    },
    {
      key: 9,
      text: 'Balance Techs Shift Utilization',
      value: 'balanceTechsShiftUtilization',
    },
    {
      key: 10,
      text: 'Disable Location Restriction Timings',
      value: 'disableAvailabilityRestriction',
    },
    {
      key: 11,
      text: 'Save Engine Setting',
      value: 'saveEngineSetting',
    },
  ];
};
